import axios from "axios";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState, useContext } from "react";
import { useTranslation } from '@/components/useTranslation';
import { MyContext } from "@/pages/_app";
import { useRouter } from "next/router";

function ContactForm() {
  const [loading, setLoading] = useState(false);
  const t = useTranslation();
  const { register, handleSubmit, formState: { errors }, setValue, getValues } = useForm();
  const [isPackageSelected, setIsPackageSelected] = useState(false);
  const router = useRouter();
  const {
    globalValue,
    setGlobalValue,
    isSelected,
    setIsSelected,
    selectedValue,
    setSelectedValue,
    priceLöschen,
    setpriceLöschen,
    selectedPlatform
  } = useContext(MyContext);
  const [selectedOption, setSelectedOption] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);

  useEffect(() => {
    if (router.pathname === '/mail') {
      localStorage.setItem('current-routes', 'mail');
    }
  }, [router.pathname]);

  useEffect(() => {
    const initialValue = '';
    setSelectedValue(initialValue);
  }, []);

  useEffect(() => {
    const selectElement = document.getElementById("selectOption");
    const optionElements = selectElement.getElementsByTagName("option");

    for (let i = 0; i < optionElements.length; i++) {
      optionElements[i].removeAttribute('selected');
      if (optionElements[i].value === selectedValue) {
        setSelectedOption(optionElements[i].value);
        optionElements[i].setAttribute('selected', 'selected');
      }
    }
  }, [selectedValue]);

  useEffect(() => {
    if (isSelected) {
      if (selectedPlatform === "Google") {
        setValue("package_id", 230);
      } else if (selectedPlatform === "Jameda") {
        setValue("package_id", 469);
      }
      setValue("quantity", parseInt(globalValue));
      setValue("price", parseInt(priceLöschen));
    }
  }, [isSelected, selectedPlatform, globalValue, priceLöschen, setValue]);

  useEffect(() => {
    setValue("package_id", selectedValue);
    setIsPackageSelected(true);
  }, [selectedValue, setValue]);

  useEffect(() => {
    const path = router.asPath;
    const category = path.split('/platform/')[1];

    const allOptions = [
      { value: "120", label: `Google ${t.basic} - 25 ${t.reviews}`, category: "Google" },
      { value: "121", label: `Google ${t.business} - 50 ${t.reviews}`, category: "Google" },
      { value: "123", label: `Google ${t.pro} - 100 ${t.reviews}`, category: "Google" },
      { value: "129", label: `Google Local Guide ${t.basic} - 25 ${t.reviews}`, category: "Google Local Guide" },
      { value: "130", label: `Google Local Guide ${t.business} - 50 ${t.reviews}`, category: "Google Local Guide" },
      { value: "131", label: `Google Local Guide ${t.pro} - 100 ${t.reviews}`, category: "Google Local Guide" },
      { value: "133", label: `Trustpilot ${t.basic} - 25 ${t.reviews}`, category: "Trustpilot" },
      { value: "134", label: `Trustpilot ${t.business} - 50 ${t.reviews}`, category: "Trustpilot" },
      { value: "136", label: `Trustpilot ${t.pro} - 100 ${t.reviews}`, category: "Trustpilot" },
      { value: "153", label: `${t.employer} ${t.basic} - 25 ${t.reviews}`, category: "Arbeitgeber" },
      { value: "155", label: `${t.employer} ${t.business} - 50 ${t.reviews}`, category: "Arbeitgeber" },
      { value: "158", label: `${t.employer} ${t.pro} - 100 ${t.reviews}`, category: "Arbeitgeber" },
      { value: "161", label: `${t.wunschplattform} ${t.basic} - 25 ${t.reviews}`, category: "Wunschplattform" },
      { value: "163", label: `${t.wunschplattform} ${t.business} - 50 ${t.reviews}`, category: "Wunschplattform" },
      { value: "165", label: `${t.wunschplattform} ${t.pro} - 100 ${t.reviews}`, category: "Wunschplattform" },
      { value: "230", label: `Google ${t.clear2} ${t.basic} -  ${globalValue} ${globalValue == '1' ? t.review : t.reviews}`, category: "Google Loschen" },
      { value: "469", label: `Jameda ${t.clear2} ${t.basic} -  ${globalValue} ${globalValue == '1' ? t.review : t.reviews}`, category: "Jameda Loschen" },
    ];

    let filtered;
    switch (category) {
      case 'google-bewertungen-kaufen':
        filtered = allOptions.filter(option => option.category === "Google");
        break;
      case 'jameda-bewertungen-loschen':
        filtered = allOptions.filter(option => option.category === "Jameda Loschen");
        break;
      case 'google-local-guide-bewertungen-kaufen':
        filtered = allOptions.filter(option => option.category === "Google Local Guide");
        break;
      case 'trustpilot-bewertungen-kaufen':
        filtered = allOptions.filter(option => option.category === "Trustpilot");
        break;
      case 'arbeitgeber-bewertungen-kaufen':
        filtered = allOptions.filter(option => option.category === "Arbeitgeber");
        break;
      case 'wunschplattform-bewertungen-kaufen':
        filtered = allOptions.filter(option => option.category === "Wunschplattform");
        break;
      case 'google-bewertungen-loschen':
        filtered = allOptions.filter(option => option.category === "Google Loschen");
        break;
      default:
        filtered = allOptions;
    }

    setFilteredOptions(filtered);

    if (filtered.length > 0) {
      setValue("package_id", filtered[0].value);
    }
  }, [router.asPath, setValue, globalValue, t]);

  const onSubmit = (data) => {
    const storedParam = localStorage.getItem('current-routes');
    if (storedParam === 'mail') {
      data.page = 'Mail';
    }

    if (!data.package_id && !isPackageSelected) {
      toast.error(`${t.package_id_required}`, {
        position: "bottom-right",
        theme: "light",
        draggable: true,
        style: {
          borderRadius: "10px",
        },
      });
      return;
    }

    if (data.package_id == 230 || data.package_id == 469) {
      data.quantity = parseInt(globalValue);
      data.price = data.package_id == 469 ? 350 : 300;
    } else {
      data.quantity = getValues("quantity");
      data.price = getValues("price");
    }

    console.log("Gönderilen veri:", data);

    setIsPackageSelected(false);
    setLoading(true);

    axios
      .post("https://api.yaskagroup.com/public/api/contacts", data)
      .then((response) => {
        setTimeout(() => {
          setLoading(false);
          router.push('/dankeschon');
        }, 1000);
        setValue("first_name", "");
        setValue("email", "");
        setValue("phone", "");
        setValue("note", "");
        setValue("package_id", "");
        setValue("page", "");
        setValue("quantity", null);
        setValue("price", null);
        setSelectedOption("");
        setIsSelected(false);
        setGlobalValue(1);
      })
      .catch((error) => {
        console.error(error);
        setTimeout(() => {
          setLoading(false);
          toast.error(`${t.order_not_complete}`, {
            position: "bottom-right",
            theme: "light",
            draggable: true,
            style: {
              borderRadius: "10px",
            },
          });
        }, 500);
      });
  };

  return (
    <div className="w-full form-content" id="kontakt">
      <ToastContainer />
      <div
        className="p-8 bg-white rounded-3xl lg:col-span-3 lg:p-12"
        style={{
          boxShadow: "0px 5px 91.91px 9.09px rgba(29, 59, 78, 0.06)",
        }}>
        <h3 className="pb-6 text-2xl font-bold text-gray-900">{t.contact}</h3>
        <form action="true" className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
          <input type="hidden" name="website_id" value={14}
            {...register("website_id",
              { required: true, }
            )}
          ></input>

          <input
            type="hidden"
            name="quantity"
            {...register("quantity")}
          />
          <input
            type="hidden"
            name="price"
            {...register("price")}
          />
          <select
            id="selectOption"
            className={`${errors.package_id ? "!border-red-500" : ""}`}
            {...register("package_id", {
              required: true,
            })}
          >
            <option value="">{t.select_package}</option>
            {filteredOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>

          {errors.package_id && errors.package_id.type === "required" && (
            <span className="text-sm text-red-500">{t.package_id_required}</span>
          )}

          <div>
            <label className="sr-only" htmlFor="name">
              {t.name_surname}
            </label>
            <input
              placeholder={t.name_surname}
              type="text"
              id="first_name"
              {...register("first_name")}
            />
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <label className="sr-only" htmlFor="email">
                {t.email}
              </label>
              <input
                className={` ${errors.email ? "!border-red-500" : ""
                  }`}
                placeholder={t.email}
                type="email"
                id="email"
                {...register("email", {
                  required: true,
                  pattern: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
                })}
              />
              {errors.email && errors.email.type === "required" && (
                <span className="!text-red-500 text-sm">{t.email_required}</span>
              )}
              {errors.email && errors.email.type === "pattern" && (
                <span className="!text-red-500 text-sm">
                  {t.email_invalid}
                </span>
              )}
            </div>
            <div>
              <label className="sr-only" htmlFor="phone">
                {t.phone}
              </label>
              <input
                className={`${errors.phone ? "!border-red-500" : ""
                  }`}
                placeholder={t.phone}
                type="tel"
                id="phone"
                onKeyPress={(e) => {
                  if (e.key.length === 1 && !/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                {...register("phone", {
                  required: true,
                })}
              />
              {errors.phone && errors.phone.type === "required" && (
                <span className="!text-red-500 text-sm">{t.phone_required}</span>
              )}
              {errors.phone && errors.phone.type === "pattern" && (
                <span className="!text-red-500 text-sm">
                  {t.phone_invalid}
                </span>
              )}
            </div>
          </div>

          <div>
            <label className="sr-only" htmlFor="message">
              Message
            </label>
            <textarea
              placeholder={t.message}
              rows={8}
              id="note"
              {...register("note")}
            />
          </div>
          <select
            id="selectOption"
            className={`${errors.page ? "!border-red-500" : ""}`}
            {...register("page", {
              required: true,
            })}
          >
            <option value="" >Wie sind Sie auf uns aufmerksam geworden?</option>
            <option value="Google">Google</option>
            <option value="Mail">Newsletter Mail</option>
            <option value="Empfehlung">Empfehlung</option>
            <option value="Bestandskunde">Bestandskunde</option>
            <option value="Social media">Social Media</option>
          </select>

          <div className="mt-4">
            {loading ? (
              <button
                id="contactBtn"
                className="inline-block w-full px-5 py-3 font-medium text-white bg-blue-700 rounded-lg sm:w-auto"
                disabled
              >
                {t.loading}...
              </button>
            ) : (
              <button
                id="contactBtn"
                className="inline-block w-full px-5 py-3 font-medium text-white bg-blue-700 rounded-lg sm:w-auto"
                type="submit"
              >
                {t.button2}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default ContactForm;